import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Icon,
  IconButton,
  Input,
  PopoverTrigger,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Box,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { SearchOutlined, Cancel } from "@mui/icons-material";
import GaraazGeneralPopover from "./GaraazGeneralPopover";
import { useOrdersStore } from "../store/useOrdersStore";
import { useInfiniteSearchByPartNumber } from "../queryHooks";
import { useCallback, useEffect, useState, useMemo } from "react";
import services from "../services";
import useNotification from "../../../utils/useNotification";
import { formatCurrency } from "../../../utils/formatCurrency";
import { GrDownload } from "react-icons/gr";
import endpoints from "../../../utils/endpoints";
import AddPartQuantityModal from "./AddPartQuantityModal";
import HighlightedSearchText from "./HighlightedSearchText";
import { useDisclosure } from "@chakra-ui/react";
import { BillingEntity } from "../enums";
import { useGetOrderMediaConfig } from "../../PlaceOrderTest/queryHooks";
import { isAxiosError } from "axios";
import { isPartNumberCompatibleWithSearch } from "../../../utils/textUtils";

type GaraazPartConversionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isDisabled: boolean;
  orderId: string;
  remove_idFromPartDetails(partObject: any): {
    "Part Name": any;
    "Part Number": any;
    MRP: any;
    Brand: any;
    "HSN code": any;
    "Root Part Number": any;
  };
  orderData: any;
  isPartEditDisabled: boolean;
  handleQuanityValueChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    part: any,
  ) => void;
  refetchAllOrders?: () => void;
  enableEnquiryPartSearchUx?: boolean;
};

const GaraazPartConversionModal: React.FC<GaraazPartConversionModalProps> = ({
  isOpen,
  onClose,
  isDisabled,
  orderId,
  remove_idFromPartDetails,
  orderData,
  isPartEditDisabled,
  handleQuanityValueChange,
  refetchAllOrders,
  enableEnquiryPartSearchUx = false,
}) => {
  const toast = useNotification();

  const orderItems = useOrdersStore((state) => state.orderItems[orderId]);
  const setOrderItemsWithOrderId = useOrdersStore(
    (state) => state.setOrderItemsWithOrderId,
  );

  const [PartSearchValue, setPartSearchValue] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const [debouncedPartSearchValue, setDebouncedPartSearchValue] = useState("");
  const [partSearchResultBoxDisplay, setPartSearchResultBoxDisplay] =
    useState("none");

  const [alreadyExistsError, setAlreadyExistsError] = useState<any[]>([]);
  const {
    isOpen: isQuantityModalOpen,
    onOpen: onQuantityModalOpen,
    onClose: onQuantityModalClose,
  } = useDisclosure();
  const [selectedPartSnapshot, setSelectedPartSnapshot] = useState<any | null>(
    null,
  );
  const [quantity, setQuantity] = useState<string>("1");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const displayOrderItems = useMemo(() => {
    const oi = Array.isArray(orderItems) ? orderItems : [];
    const sci = Array.isArray(orderData?.supplierCancelledItems)
      ? orderData.supplierCancelledItems
      : [];
    const cbo = Array.isArray(orderData?.cboItems) ? orderData.cboItems : [];
    const merged = new Map<string, any>();

    oi.forEach((item: any) => {
      const key = String(item?.partId ?? item?._id ?? "");
      if (!key) return;
      merged.set(key, {
        ...item,
        partId: item?.partId ?? item?._id,
        orderedQuantity: Number(item?.orderedQuantity || 0),
        remainingDecisionQuantity: Number(item?.remainingDecisionQuantity || 0),
        cancelledQuantity: Number(item?.cancelledQuantity || 0),
        holdQuantity: Number(item?.holdQuantity || 0),
        givenQuantity: Number(item?.givenQuantity || 0),
        approvedQuantity: Number(item?.approvedQuantity || 0),
        rejectedQuantity: Number(item?.rejectedQuantity || 0),
        supplierCancelledQuantity: Number(item?.supplierCancelledQuantity || 0),
        supplierCancelledHoldQuantity: Number(
          item?.supplierCancelledHoldQuantity || 0,
        ),
        cboQuantity: Number(item?.cboQuantity || 0),
        cboHoldQuantity: Number(item?.cboHoldQuantity || 0),
      });
    });

    sci.forEach((item: any) => {
      const key = String(item?.partId ?? item?._id ?? "");
      if (!key) return;
      const existing = merged.get(key);
      if (!existing) {
        merged.set(key, {
          ...item,
          partId: item?.partId ?? item?._id,
          orderedQuantity: 0,
          remainingDecisionQuantity: 0,
          cancelledQuantity: Number(item?.cancelledQuantity || 0),
          holdQuantity: 0,
          givenQuantity: 0,
          approvedQuantity: 0,
          rejectedQuantity: 0,
          supplierCancelledQuantity: Number(
            item?.remainingDecisionQuantity || item?.orderedQuantity || 0,
          ),
          supplierCancelledHoldQuantity: Number(item?.holdQuantity || 0),
          cboQuantity: 0,
          cboHoldQuantity: 0,
        });
        return;
      }

      merged.set(key, {
        ...existing,
        cancelledQuantity:
          Number(existing?.cancelledQuantity || 0) +
          Number(item?.cancelledQuantity || 0),
        supplierCancelledQuantity:
          Number(existing?.supplierCancelledQuantity || 0) +
          Number(item?.remainingDecisionQuantity || 0),
        supplierCancelledHoldQuantity:
          Number(existing?.supplierCancelledHoldQuantity || 0) +
          Number(item?.holdQuantity || 0),
      });
    });

    cbo.forEach((item: any) => {
      const key = String(item?.partId ?? item?._id ?? "");
      if (!key) return;
      const existing = merged.get(key);
      if (!existing) {
        merged.set(key, {
          ...item,
          partId: item?.partId ?? item?._id,
          orderedQuantity: 0,
          remainingDecisionQuantity: 0,
          cancelledQuantity: Number(item?.cancelledQuantity || 0),
          holdQuantity: 0,
          givenQuantity: 0,
          approvedQuantity: 0,
          rejectedQuantity: 0,
          supplierCancelledQuantity: 0,
          supplierCancelledHoldQuantity: 0,
          cboQuantity: Number(
            item?.remainingDecisionQuantity || item?.orderedQuantity || 0,
          ),
          cboHoldQuantity: Number(item?.holdQuantity || 0),
        });
        return;
      }

      merged.set(key, {
        ...existing,
        cancelledQuantity:
          Number(existing?.cancelledQuantity || 0) +
          Number(item?.cancelledQuantity || 0),
        cboQuantity:
          Number(existing?.cboQuantity || 0) +
          Number(item?.remainingDecisionQuantity || 0),
        cboHoldQuantity:
          Number(existing?.cboHoldQuantity || 0) + Number(item?.holdQuantity || 0),
      });
    });

    return Array.from(merged.values());
  }, [orderItems, orderData?.supplierCancelledItems, orderData?.cboItems]);

  const hasAnyCustomerCancelled = useMemo(
    () => displayOrderItems.some((item: any) => Number(item?.cancelledQuantity || 0) > 0),
    [displayOrderItems],
  );
  const hasAnyHold = useMemo(
    () =>
      displayOrderItems.some(
        (item: any) =>
          Number(item?.holdQuantity || 0) > 0 ||
          Number(item?.supplierCancelledHoldQuantity || 0) > 0,
      ),
    [displayOrderItems],
  );
  const hasAnySupplierCancelled = useMemo(
    () =>
      displayOrderItems.some(
        (item: any) => Number(item?.supplierCancelledQuantity || 0) > 0,
      ),
    [displayOrderItems],
  );
  const hasAnySupplierCancelledHold = useMemo(
    () =>
      displayOrderItems.some(
        (item: any) => Number(item?.supplierCancelledHoldQuantity || 0) > 0,
      ),
    [displayOrderItems],
  );
  const hasAnyCbo = useMemo(
    () => displayOrderItems.some((item: any) => Number(item?.cboQuantity || 0) > 0),
    [displayOrderItems],
  );
  const hasAnyCboHold = useMemo(
    () => displayOrderItems.some((item: any) => Number(item?.cboHoldQuantity || 0) > 0),
    [displayOrderItems],
  );

  const {
    data: infiniteParts,
    isLoading: partsLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteSearchByPartNumber(debouncedPartSearchValue);

  const parts = useMemo(() => {
    return infiniteParts?.pages.flatMap((p) => p.items) || [];
  }, [infiniteParts]);

  const partSearchMismatch = useMemo(() => {
    if (!enableEnquiryPartSearchUx) return null;
    const part = selectedPartSnapshot;
    if (!part) return null;
    const q = PartSearchValue.trim();
    if (!q) return null;
    const pn = String(part.partNumber ?? "").trim();
    const name = String(part.partName ?? "").trim();
    if (isPartNumberCompatibleWithSearch(PartSearchValue, pn, name)) return null;
    return {
      search: q,
      selectedPartNumber: pn,
      selectedPartName: name,
    };
  }, [
    enableEnquiryPartSearchUx,
    selectedPartSnapshot,
    PartSearchValue,
  ]);

  const handleScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      scrollHeight - scrollTop <= clientHeight + 1 &&
      hasNextPage &&
      !isFetchingNextPage
    ) {
      fetchNextPage();
    }
  };
  const { data: mobileConfigs } = useGetOrderMediaConfig();

  const isInsuranceEnquiryOrder = useMemo(() => {
    const isEnquiryOrder =
      orderData?.requireEstimate === true &&
      orderData?.rootOrderId === orderData?._id;
    const isInsuranceEntity =
      orderData?.billingDetails?.billingEntity ===
      BillingEntity.INSURANCE_COMPANY;
    const insurerFamily =
      orderData?.billingAddress?.billingCustomerInsurerFamily ??
      orderData?.billingDetails?.billingCustomerInsurerFamily;
    const eligibleFamilies =
      mobileConfigs?.eligible_insurer_families_for_approval ?? [];
    const isEligibleForApproval =
      Array.isArray(eligibleFamilies) &&
      eligibleFamilies.length > 0 &&
      typeof insurerFamily === "string" &&
      eligibleFamilies.some(
        (f: string) =>
          String(f).trim().toLowerCase() ===
          String(insurerFamily).trim().toLowerCase(),
      );
    return isEnquiryOrder && isInsuranceEntity && isEligibleForApproval;
  }, [
    orderData?.requireEstimate,
    orderData?.rootOrderId,
    orderData?._id,
    orderData?.billingDetails?.billingEntity,
    orderData?.billingAddress?.billingCustomerInsurerFamily,
    orderData?.billingDetails?.billingCustomerInsurerFamily,
    mobileConfigs?.eligible_insurer_families_for_approval,
  ]);

  const debounce = useCallback((value: string) => {
    const timer = setTimeout(() => {
      setDebouncedPartSearchValue(value);
    }, 0);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    setAlreadyExistsError(Array(parts?.length).fill(""));
  }, [parts]);
  useEffect(() => {
    return debounce(PartSearchValue);
  }, [PartSearchValue, debounce]);

  function handlePartSearchValueChange(e: React.ChangeEvent<HTMLInputElement>) {
    setPartSearchValue(e.target.value);
  }

  function handlePartClick(index: number) {
    if (isPartEditDisabled) return;

    if (parts) {
      const alreadyExists = orderItems.some(
        (part: any) => part.partId === parts[index]._id,
      );
      if (alreadyExists) {
        setAlreadyExistsError((previousAlreadyExistsError) => {
          const newArray = [...previousAlreadyExistsError];
          newArray[index] = "Already Exists";
          return newArray;
        });
        return;
      }

      // Open quantity modal — capture part at click so async `parts` refreshes cannot drift selection
      setSelectedPartSnapshot(parts[index]);
      setQuantity("1");
      onQuantityModalOpen();
    }
  }

  async function handleAddPartWithQuantity() {
    const part = selectedPartSnapshot;
    if (!part) return;

    const quantityNum = parseInt(quantity);

    // Validate quantity
    if (isNaN(quantityNum) || quantityNum < 1) {
      toast({
        description: "Quantity must be at least 1",
        status: "error",
      });
      return;
    }
    const alreadyExists = orderItems.some(
      (item: any) => item.partId === part._id,
    );

    if (alreadyExists) {
      toast({
        description: "Part already exists in order",
        status: "error",
      });
      return;
    }

    try {
      setIsSubmitting(true);
      await services.orderItemsAction(orderData.orderNo, "ADD", [
        {
          partId: part._id,
          quantity: quantityNum,
        },
      ]);
      setOrderItemsWithOrderId(orderId, [
        {
          ...part,
          partId: part._id,
          orderedQuantity: quantityNum,
          remainingDecisionQuantity: quantityNum,
          holdQuantity: 0,
          cancelledQuantity: 0,
          givenQuantity: 0,
        },
        ...orderItems,
      ]);
      setPartSearchResultBoxDisplay("none");
      setPartSearchValue("");
      onQuantityModalClose();
      setSelectedPartSnapshot(null);
      setQuantity("1");
      refetchAllOrders?.();
    } catch (error) {
      let errorMessage =
        "There was an error in Inserting the part, please try again";
      if (isAxiosError(error)) {
        errorMessage =
          error.response?.data?.statusCode === 409
            ? error.response?.data?.errorMsg
            : errorMessage;
      }
      toast({
        description: errorMessage,
        status: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  async function handleDeleteRow(index: number) {
    try {
      const updatedPart = await services.deletePart(orderId, {
        partId: orderItems[index].partId,
        orderedQuantity: orderItems[index].orderedQuantity,
      });
      let updatedOrderItems = [...orderItems];
      updatedOrderItems.splice(index, 1);
      setOrderItemsWithOrderId(orderId, updatedOrderItems);
    } catch (error: any) {
      toast({
        description:
          "There was an error in deleting the part, please try again",
        status: "error",
      });
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={"6xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader display={"flex"} justifyContent={"space-between"}>
            Price Estimate
            <div>
              Total Price:&nbsp;
              <Text color={"#3081cc"} display={"inline"}>
                {formatCurrency(
                  displayOrderItems.reduce((accumulator: any, currentValue: any) => {
                    return (
                      accumulator +
                      currentValue["mrp"] *
                        (currentValue["remainingDecisionQuantity"]
                          ? currentValue["remainingDecisionQuantity"]
                          : 0)
                    );
                  }, 0),
                )}
              </Text>
              <Icon
                as={GrDownload}
                cursor={"pointer"}
                color={"#4A5567"}
                mr={10}
                ml={4}
                fontSize={"sm"}
                onClick={() => {
                  window.open(
                    `${
                      process.env.REACT_APP_BASE_URL
                    }${endpoints.exportOrderDetailsAsCsv(orderId)}`,
                    "_blank",
                  );
                }}
              ></Icon>
            </div>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box flex={1} height={"100%"} style={{ margin: 0 }}>
              <Box
                display={"flex"}
                alignItems={"center"}
                width={"100%"}
                height={"10%"}
              >
                <Icon mr={2}>
                  <SearchOutlined fontSize="large"></SearchOutlined>
                </Icon>
                <Box position={"relative"} width={"100%"}>
                  <Box display={"flex"} position={"relative"}>
                    <Input
                      isDisabled={isPartEditDisabled}
                      id={`part-search-input-${orderId}`}
                      value={PartSearchValue}
                      size={"sm"}
                      placeholder="Search By Part Number Or Name"
                      onChange={(e) => {
                        handlePartSearchValueChange(e);
                        setPartSearchResultBoxDisplay("flex");
                      }}
                      borderRadius={"10px"}
                    />
                    {partsLoading && (
                      <Spinner
                        position={"absolute"}
                        right={2}
                        top={1}
                      ></Spinner>
                    )}
                  </Box>
                  <Box
                    display={`${partSearchResultBoxDisplay}`}
                    position={"absolute"}
                    width={"100%"}
                    height={"200px"}
                    backgroundColor={"white"}
                    flexDirection={"column"}
                    overflow={"auto"}
                    border={"1px solid lightgrey"}
                    borderRadius={"0px 0px 5px 5px"}
                    zIndex={1}
                    onScroll={handleScroll}
                  >
                    <IconButton
                      width={"fit-content"}
                      icon={<Cancel fontSize="small"></Cancel>}
                      aria-label=""
                      position={"sticky"}
                      size={"xs"}
                      right={"10px"}
                      top={0}
                      marginTop={"2px"}
                      marginLeft={"auto"}
                      onClick={() => {
                        setPartSearchResultBoxDisplay("none");
                      }}
                    ></IconButton>

                    <Box padding={"10px"}>
                      {partsLoading && <Text>Loading...</Text>}

                      {!partsLoading &&
                        parts?.map((part: any, index: number) => (
                          <Box
                            key={index}
                            display={"flex"}
                            mb={2}
                            padding={"5px"}
                            borderRadius={"5px"}
                            _hover={
                              !isPartEditDisabled
                                ? { backgroundColor: "#F0F6F6" }
                                : {}
                            }
                            transition={"all 0.3s"}
                            onClick={() => {
                              if (!isPartEditDisabled) handlePartClick(index);
                            }}
                            cursor={
                              isPartEditDisabled ? "not-allowed" : "pointer"
                            }
                            border={"0.5px solid lightgrey"}
                            opacity={isPartEditDisabled ? 0.6 : 1}
                          >
                            <Box>
                              <Text>
                                {enableEnquiryPartSearchUx ? (
                                  <HighlightedSearchText
                                    text={part.partNumber}
                                    query={PartSearchValue}
                                  />
                                ) : (
                                  part.partNumber
                                )}
                              </Text>
                              <Text noOfLines={1}>
                                {enableEnquiryPartSearchUx ? (
                                  <HighlightedSearchText
                                    text={part.partName}
                                    query={PartSearchValue}
                                  />
                                ) : (
                                  part.partName
                                )}
                              </Text>
                            </Box>
                            {alreadyExistsError[index] !== "" && (
                              <Text color={"red"} marginLeft={"auto"} mr={5}>
                                {alreadyExistsError[index]}
                              </Text>
                            )}
                          </Box>
                        ))}
                      {isFetchingNextPage && (
                        <Spinner size="sm" m="auto" mt={2} mb={2} />
                      )}
                      {(!parts || parts?.length === 0) && !partsLoading && (
                        <Text>No Options </Text>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                width={"100%"}
                mt={3}
                height={"90%"}
                overflowY={"scroll"}
                boxSizing="border-box"
                mb={2}
              >
                <TableContainer>
                  <Table
                    variant="simple"
                    width={"100%"}
                    overflowY={"scroll"}
                    height={"100%"}
                  >
                    <Thead width={"100%"} height={"fit-content"}>
                      <Tr
                        padding={"5px"}
                        display={"flex"}
                        width={"100%"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        borderBottom={"1px solid #EDF2F6"}
                      >
                        <Th border={"none"} padding={"0"} width={"20%"}>
                          <Text fontSize={"xs"}>Part No.</Text>
                        </Th>

                        <Th border={"none"} padding={"0"} width={"20%"}>
                          Part Name
                        </Th>

                        <Th
                          border={"none"}
                          padding={"0"}
                          isNumeric
                          width={"15%"}
                          textAlign={"center"}
                        >
                          <Text textAlign={"center"} fontSize={"xs"}>
                            {" "}
                            {orderData?.orderType === "RETURN"
                              ? "Returned Ordered"
                              : "Ordered"}
                          </Text>
                        </Th>
                        {orderData.orderType === "REGULAR" &&
                          !orderData.requireEstimate && (
                            <Th
                              border={"none"}
                              padding={"0"}
                              isNumeric
                              width={"15%"}
                              textAlign={"center"}
                            >
                              <Text textAlign={"center"} fontSize={"xs"}>
                                Given
                              </Text>
                            </Th>
                          )}
                        {orderData.requireEstimate && (
                          <>
                            <Th
                              border={"none"}
                              padding={"0"}
                              isNumeric
                              width={"12%"}
                              textAlign={"center"}
                            >
                              <Text textAlign={"center"} fontSize={"xs"}>
                                Active
                              </Text>
                            </Th>
                            {hasAnyCustomerCancelled && (
                              <Th
                                border={"none"}
                                padding={"0"}
                                isNumeric
                                width={"12%"}
                                textAlign={"center"}
                              >
                                <Text textAlign={"center"} fontSize={"xs"}>
                                  Cancelled
                                </Text>
                              </Th>
                            )}
                            {hasAnyHold && (
                              <Th
                                border={"none"}
                                padding={"0"}
                                isNumeric
                                width={"12%"}
                                textAlign={"center"}
                              >
                                <Text textAlign={"center"} fontSize={"xs"}>
                                  Hold
                                </Text>
                              </Th>
                            )}
                            {isInsuranceEnquiryOrder && (
                              <>
                                <Th
                                  border={"none"}
                                  padding={"0"}
                                  isNumeric
                                  width={"12%"}
                                  textAlign={"center"}
                                >
                                  <Text textAlign={"center"} fontSize={"xs"}>
                                    Approved
                                  </Text>
                                </Th>
                                <Th
                                  border={"none"}
                                  padding={"0"}
                                  isNumeric
                                  width={"12%"}
                                  textAlign={"center"}
                                >
                                  <Text textAlign={"center"} fontSize={"xs"}>
                                    Rejected
                                  </Text>
                                </Th>
                              </>
                            )}
                          </>
                        )}
                        {hasAnySupplierCancelled && (
                          <Th
                            border={"none"}
                            padding={"0"}
                            isNumeric
                            width={"12%"}
                            textAlign={"center"}
                          >
                            <Tooltip label="Supplier Cancelled" hasArrow>
                              <Text
                                textAlign={"center"}
                                fontSize={"0.70rem"}
                                cursor="pointer"
                              >
                                SC
                              </Text>
                            </Tooltip>
                          </Th>
                        )}
                        {hasAnySupplierCancelledHold && (
                          <Th
                            border={"none"}
                            padding={"0"}
                            isNumeric
                            width={"12%"}
                            textAlign={"center"}
                          >
                            <Tooltip label="Hold After Supplier Cancellation" hasArrow>
                              <Text
                                textAlign={"center"}
                                fontSize={"0.70rem"}
                                cursor="pointer"
                              >
                                HSC
                              </Text>
                            </Tooltip>
                          </Th>
                        )}
                        {hasAnyCbo && (
                          <Th
                            border={"none"}
                            padding={"0"}
                            isNumeric
                            width={"12%"}
                            textAlign={"center"}
                          >
                            <Tooltip label="CBO" hasArrow>
                              <Text
                                textAlign={"center"}
                                fontSize={"xs"}
                                cursor="pointer"
                              >
                                CBO
                              </Text>
                            </Tooltip>
                          </Th>
                        )}
                        {hasAnyCboHold && (
                          <Th
                            border={"none"}
                            padding={"0"}
                            isNumeric
                            width={"12%"}
                            textAlign={"center"}
                          >
                            <Tooltip label="Hold After CBO" hasArrow>
                              <Text
                                textAlign={"center"}
                                fontSize={"xs"}
                                cursor="pointer"
                              >
                                HCBO
                              </Text>
                            </Tooltip>
                          </Th>
                        )}
                        <Th
                          border={"none"}
                          padding={"0"}
                          isNumeric
                          width={"10%"}
                        >
                          <Text textAlign={"center"} fontSize={"xs"}>
                            MRP
                          </Text>
                        </Th>

                        <Th
                          border={"none"}
                          padding={"0"}
                          width={"10%"}
                          textAlign={"end"}
                          cursor={"pointer"}
                          mr={"1em"}
                        >
                          {" "}
                          <Text
                            fontSize={"8px"}
                            fontWeight={"normal"}
                            color={"#0096e0"}
                          >
                            {displayOrderItems.length} Parts Added
                          </Text>
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody width={"100%"} height={"100%"}>
                      {displayOrderItems.length > 0 &&
                        Object.entries(displayOrderItems[0])?.length !== 0 &&
                        displayOrderItems.map((part: any, index: number) => (
                          <Tr
                            key={index}
                            padding={"2px"}
                            fontSize={"x-small"}
                            width={"100%"}
                            textColor={"black"}
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            borderBottom={"1px solid #EDF2F6"}
                            onMouseEnter={() => {
                              setHoveredIndex(index);
                            }}
                            onMouseLeave={() => {
                              setHoveredIndex(null);
                            }}
                            _hover={{ backgroundColor: "#F0F6F6" }}
                          >
                            <Td padding={"0"} width={"20%"} border={"none"}>
                              <GaraazGeneralPopover
                                ArekeysVisible={true}
                                CopierKeys={[]}
                                title="Part Details"
                                value={[
                                  remove_idFromPartDetails(displayOrderItems[index]),
                                ]}
                              >
                                <PopoverTrigger>
                                  <Text
                                    cursor={"pointer"}
                                    noOfLines={1}
                                    whiteSpace={"normal"}
                                    fontSize={"xs"}
                                    color={"#1a202c"}
                                  >
                                    {displayOrderItems[index].partNumber}
                                  </Text>
                                </PopoverTrigger>
                              </GaraazGeneralPopover>
                            </Td>

                            <Td padding={"0"} width={"20%"} border={"none"}>
                              <Text
                                whiteSpace={"normal"}
                                noOfLines={1}
                                color={"#1a202c"}
                                fontSize={"xs"}
                              >
                                {displayOrderItems[index].partName}
                              </Text>
                            </Td>

                            {/* <Td
                            padding={"0"}
                            width={"15%"}
                            isNumeric
                            border={"none"}
                          >
                            <Text width={"100%"} textAlign={"center"}>
                              <Input
                                isDisabled={isDisabled}
                                id={`part-quantity-${orderId}-${index}`}
                                backgroundColor={"white"}
                                size={"xs"}
                                type="number"
                                padding={0}
                                paddingLeft={1}
                                width={"50%"}
                                maxWidth={"50px"}
                                zIndex={0}
                                min={1}
                                value={part.orderedQuantity}
                                onChange={(e) => {
                                  handleQuanityValueChange(e, part);
                                }}
                                height={"85%"}
                              ></Input>
                            </Text>
                          </Td> */}
                            <Td
                              padding={"0"}
                              width={"15%"}
                              isNumeric
                              border={"none"}
                            >
                              <Text width={"100%"} textAlign={"center"}>
                                {part.orderedQuantity || 0}
                              </Text>
                            </Td>
                            {orderData.orderType === "REGULAR" &&
                              !orderData.requireEstimate && (
                                <Td
                                  padding={"0"}
                                  width={"15%"}
                                  isNumeric
                                  border={"none"}
                                >
                                  <Text width={"100%"} textAlign={"center"}>
                                    {part.givenQuantity || 0}
                                  </Text>
                                </Td>
                              )}
                            {orderData.requireEstimate && (
                              <>
                                <Td
                                  padding={"0"}
                                  width={"12%"}
                                  isNumeric
                                  border={"none"}
                                >
                                  <Text width={"100%"} textAlign={"center"}>
                                    {part.remainingDecisionQuantity || 0}
                                  </Text>
                                </Td>
                                {hasAnyCustomerCancelled && (
                                  <Td
                                    padding={"0"}
                                    width={"12%"}
                                    isNumeric
                                    border={"none"}
                                  >
                                    <Text width={"100%"} textAlign={"center"}>
                                      {part.cancelledQuantity || 0}
                                    </Text>
                                  </Td>
                                )}
                                {hasAnyHold && (
                                  <Td
                                    padding={"0"}
                                    width={"12%"}
                                    isNumeric
                                    border={"none"}
                                  >
                                    <Text width={"100%"} textAlign={"center"}>
                                      {(part.holdQuantity || 0) +
                                        (part.supplierCancelledHoldQuantity || 0)}
                                    </Text>
                                  </Td>
                                )}
                                {isInsuranceEnquiryOrder && (
                                  <>
                                    <Td
                                      padding={"0"}
                                      width={"12%"}
                                      isNumeric
                                      border={"none"}
                                    >
                                      <Text width={"100%"} textAlign={"center"}>
                                        {part.approvedQuantity || 0}
                                      </Text>
                                    </Td>
                                    <Td
                                      padding={"0"}
                                      width={"12%"}
                                      isNumeric
                                      border={"none"}
                                    >
                                      <Text width={"100%"} textAlign={"center"}>
                                        {part.rejectedQuantity || 0}
                                      </Text>
                                    </Td>
                                  </>
                                )}
                              </>
                            )}
                            {hasAnySupplierCancelled && (
                              <Td
                                padding={"0"}
                                width={"12%"}
                                isNumeric
                                border={"none"}
                              >
                                <Text width={"100%"} textAlign={"center"}>
                                  {part.supplierCancelledQuantity || 0}
                                </Text>
                              </Td>
                            )}
                            {hasAnySupplierCancelledHold && (
                              <Td
                                padding={"0"}
                                width={"12%"}
                                isNumeric
                                border={"none"}
                              >
                                <Text width={"100%"} textAlign={"center"}>
                                  {part.supplierCancelledHoldQuantity || 0}
                                </Text>
                              </Td>
                            )}
                            {hasAnyCbo && (
                              <Td
                                padding={"0"}
                                width={"12%"}
                                isNumeric
                                border={"none"}
                              >
                                <Text width={"100%"} textAlign={"center"}>
                                  {part.cboQuantity || 0}
                                </Text>
                              </Td>
                            )}
                            {hasAnyCboHold && (
                              <Td
                                padding={"0"}
                                width={"12%"}
                                isNumeric
                                border={"none"}
                              >
                                <Text width={"100%"} textAlign={"center"}>
                                  {part.cboHoldQuantity || 0}
                                </Text>
                              </Td>
                            )}
                            <Td
                              padding={"0"}
                              width={"10%"}
                              border={"none"}
                              justifyContent={"center"}
                              display={"flex"}
                              alignItems={"center"}
                            >
                              <Text textAlign={"center"} fontSize={"xs"}>
                                {formatCurrency(displayOrderItems[index].mrp)}
                              </Text>
                            </Td>

                            <Td
                              width={"10%"}
                              textAlign={"end"}
                              padding={"0"}
                              border={"none"}
                              opacity={`${hoveredIndex === index ? 1 : 0}`}
                              marginRight={"1.5em"}
                            >
                              {/* <IconButton
                              isDisabled={isDisabled}
                              aria-label=""
                              onClick={() => {
                                handleDeleteRow(index);
                              }}
                              backgroundColor={"#BBE6E3"}
                              size={"xs"}
                              height={"20px"}
                            >
                              <DeleteIcon
                                style={{ fontSize: "1.3em" }}
                              ></DeleteIcon>
                            </IconButton> */}
                            </Td>
                          </Tr>
                        ))}

                      <Tr
                        key={-1}
                        padding={"2px"}
                        fontSize={"x-small"}
                        width={"100%"}
                        textColor={"black"}
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <Td padding={"0"} width={"20%"} border={"none"}></Td>
                        <Td padding={"0"} width={"20%"} border={"none"}></Td>
                        <Td
                          padding={"0"}
                          width={"20%"}
                          isNumeric
                          border={"none"}
                        ></Td>
                        {orderData.orderType === "REGULAR" && (
                          <Td
                            padding={"0"}
                            width={"20%"}
                            isNumeric
                            border={"none"}
                          ></Td>
                        )}

                        <Td
                          padding={"0"}
                          width={"10%"}
                          border={"none"}
                          textAlign={"end"}
                          fontWeight={"bold"}
                          display={"flex"}
                          justifyContent={"flex-end"}
                        >
                          {/* Total Price:&nbsp;
                          <Text color={"#3081cc"} display={"inline"}>
                            {formatCurrency(
                              orderItems.reduce(
                                (accumulator: any, currentValue: any) => {
                                  return (
                                    accumulator +
                                    currentValue["mrp"] *
                                      (currentValue["remainingDecisionQuantity"]
                                        ? currentValue[
                                            "remainingDecisionQuantity"
                                          ]
                                        : 0)
                                  );
                                },
                                0,
                              ),
                            )}
                          </Text> */}
                        </Td>
                        {hasAnySupplierCancelled && (
                          <Td
                            padding={"0"}
                            width={"12%"}
                            isNumeric
                            border={"none"}
                          ></Td>
                        )}
                        {hasAnySupplierCancelledHold && (
                          <Td
                            padding={"0"}
                            width={"12%"}
                            isNumeric
                            border={"none"}
                          ></Td>
                        )}
                        {hasAnyCbo && (
                          <Td
                            padding={"0"}
                            width={"12%"}
                            isNumeric
                            border={"none"}
                          ></Td>
                        )}
                        {hasAnyCboHold && (
                          <Td
                            padding={"0"}
                            width={"12%"}
                            isNumeric
                            border={"none"}
                          ></Td>
                        )}
                        <Td
                          width={"10%"}
                          textAlign={"end"}
                          padding={"0"}
                          border={"none"}
                          marginRight={"1.5em"}
                        ></Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Done
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <AddPartQuantityModal
        isOpen={isQuantityModalOpen}
        onClose={() => {
          onQuantityModalClose();
          setSelectedPartSnapshot(null);
          setQuantity("1");
        }}
        selectedPart={selectedPartSnapshot}
        quantity={quantity}
        onQuantityChange={setQuantity}
        onConfirm={handleAddPartWithQuantity}
        remove_idFromPartDetails={remove_idFromPartDetails}
        isLoading={isSubmitting}
        partSearchMismatch={partSearchMismatch}
      />
    </>
  );
};

export default GaraazPartConversionModal;
